export default __webpack_public_path__ + "static/media/checked.e22cc779.svg";